/**
 * @ngdoc service
 * @name checkins.factory:emailRsvps
 *
 * @description
 *
 */
import rsvpBulkMessageModalCreator from '../../../../modules/messages/helpers/rsvp-bulk-message-modal-creator';

angular
    .module('festzelt-os.guestlists')
    .factory('emailRsvps', [
        '$injector',
        ($injector) => new EmailRsvpsWorkflow($injector)
    ]);

class EmailRsvpsWorkflow {
    constructor($injector) {
        this.injector = $injector;
        this.translate = this.injector.get('$translate');

        this.key = 'email-rsvps';
        this.title = this.translate.instant('guestlists.workflows.rsvps-list.email-rsvps');
        this.level = 'selected';
    }

    action(payload, store) {
        rsvpBulkMessageModalCreator(this.injector, store, store.state.vm.guestlist);
    }
}



function emailRsvps($translate, $injector) {
    return {

    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/email-rsvps.js